import { HeartHandshake, History, Sparkles } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Bottom nav:
 *   [Coach] [History] [Insights]
 *
 * - Coach    start a session and ride out a live tantrum (the session detail
 *            route lives under /session/, so keep Coach active there too)
 * - History  past sessions, re-readable as transcripts
 * - Insights AI patterns across resolved sessions
 *
 * Settings (child profiles) is reached via the shell's top-right gear, not here.
 */
export const coregulateBottomNav: BottomNavItem[] = [
  {
    id: 'coach',
    label: 'Coach',
    icon: HeartHandshake,
    href: '/apps/co-regulate',
    matchPrefixes: ['/apps/co-regulate/session/'],
  },
  { id: 'history', label: 'History', icon: History, href: '/apps/co-regulate/history' },
  {
    id: 'insights',
    label: 'Insights',
    icon: Sparkles,
    href: '/apps/co-regulate/insights',
  },
]
